module.exports = __webpack_public_path__ + "static/img/sdaqgl_gggxwhtz_one-1.e63356e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdaqgl_gggxwhtz_one-1.png
// module id = gPUZ
// module chunks = 21